import isp from "../assets/isp.png";
import fitme from "../assets/fitme.png";
import umrahTrip from "../assets/umrahTrip.png";

export const Projects = [
  {
    title: "An ISP website",
    link: "https://lightspeedisp.netlify.app/",
    sourceCode: "https://github.com/HaroonMalik66/lightspeed.git",
    ss: isp,
    techs: ["React", "CSS", "JavaScript"],
  },

  {
    title: "Travel Website",
    link: "https://umrah-trip.netlify.app",
    sourceCode: "https://github.com/HaroonMalik66/umrah-trip.git",
    ss: umrahTrip,
    techs: ["React", "CSS", "JavaScript"],
  },
  {
    title: "Gym website",
    link: "https://fitme-club.netlify.app/",
    sourceCode: "https://github.com/HaroonMalik66/fitme-club.git",
    ss: fitme,
    techs: ["React", "CSS", "JavaScript"],
  },
];
